/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { zodResolver } from "@hookform/resolvers/zod";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";

import FindUserResults from "./FindUserResults";
import { generateDefaultValues, schema, Schema } from "./schema";
import { PageTitle } from "../../components/Common/PageTitle";
import { HookForm } from "../../components/HookForm/HookForm";
import { Input } from "../../components/HookForm/Input";
import { AccountData } from "../../models/AccountData";
import DataSvc from "../../services/dataSvc";

import "./styles.scss";

type IFindUserAccountPageProps = RouteComponentProps<any>;

const FindUserAccountPage: React.FunctionComponent<
  IFindUserAccountPageProps
> = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`findUserAccountPage.${key}`);

  const [account, setAccount] = useState<AccountData | undefined>();

  const form = useForm<Schema>({
    resolver: zodResolver(schema),
    defaultValues: generateDefaultValues(),
  });

  const { data: accountData, refetch } = useQuery(
    ["findUserAccount", form.watch("email")],
    async () => {
      return DataSvc.findUserAccount(form.watch("email"));
    },
    {
      enabled: false,
    }
  );

  useEffect(() => {
    if (accountData) {
      setAccount(accountData);
    }
  }, [accountData]);

  return (
    <>
      <div className="right-content find-account">
        <div className="top-title-bar flex-grid">
          <PageTitle text={t("find_user_account")} />
          <div className="rights"></div>
          <div className="line"></div>
        </div>

        <div className="white-border-panel">
          <div className="find-account__main">
            <h3>{t("input_email_here")}</h3>
            <HookForm
              form={form}
              onSubmit={refetch}
              className="find-account__form"
              contentClassName="find-account__form-fields"
              submitButtonLabel={t("search")}
            >
              <Input name="email" />
            </HookForm>
            <hr />
            <div className="find-account__main__result">
              <h3>{t("result")}</h3>
              {account && <FindUserResults accountData={account} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(FindUserAccountPage);
